import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IProcessConfig } from 'src/app/user-identification/models/user-identification';
import { UserAgentService } from '../user-agent.service';

@Injectable({
	providedIn: 'root',
})
export class ConfigService {
	private userAgentService = inject(UserAgentService);

	private config: BehaviorSubject<IProcessConfig> = new BehaviorSubject<IProcessConfig>(null);
	public config$: Observable<IProcessConfig> = this.config.asObservable();

	public getConfig(): Observable<IProcessConfig> {
		return this.config.asObservable();
	}

	public getCurrentConfig(): IProcessConfig {
		return this.config.value;
	}

	public setConfig(config: IProcessConfig): void {
		this.isDeviceAllowed(config);
		this.config.next(config);
	}

	private isDeviceAllowed(config: IProcessConfig): void {
		config.isDeviceAllowed =
			(this.userAgentService.isMobile() && config.allowed_device.includes('mobile')) ||
			(this.userAgentService.isPC() && config.allowed_device.includes('pc'));
	}
}
